'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplCandyGuard = require('@metaplex-foundation/mpl-candy-guard');
var errors = require('../errors.cjs');
var Serializer = require('../../../types/Serializer.cjs');

/**
 * The nftGate guard restricts minting to holders
 * of a specified NFT collection.
 *
 * This means the mint address of an NFT from this
 * collection must be passed when minting.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 *
 * @see {@link NftGateGuardMintSettings} for more
 * information on the mint settings of this guard.
 */

/** @internal */
const nftGateGuardManifest = {
  name: 'nftGate',
  settingsBytes: 32,
  settingsSerializer: Serializer.createSerializerFromBeet(mplCandyGuard.nftGateBeet),
  mintSettingsParser: ({
    metaplex,
    mintSettings,
    payer,
    programs
  }) => {
    if (!mintSettings) {
      throw new errors.GuardMintSettingsMissingError('nftGate');
    }
    const tokenAccount = mintSettings.tokenAccount ?? metaplex.tokens().pdas().associatedTokenAccount({
      mint: mintSettings.mint,
      owner: payer.publicKey,
      programs
    });
    const tokenMetadata = metaplex.nfts().pdas().metadata({
      mint: mintSettings.mint,
      programs
    });
    return {
      arguments: Buffer.from([]),
      remainingAccounts: [{
        isSigner: false,
        address: tokenAccount,
        isWritable: false
      }, {
        isSigner: false,
        address: tokenMetadata,
        isWritable: false
      }]
    };
  }
};

exports.nftGateGuardManifest = nftGateGuardManifest;
//# sourceMappingURL=nftGate.cjs.map
